export const translations = {
  it: {
    nav: {
      chiSiamo: "Chi siamo",
      network: "Il nostro network",
      video: "Canali video",
      percheNoi: "Perché noi",
      solutions: "Soluzioni",
      numeri: "Numeri",
      group: "Il Gruppo",
      projects: "Progetti",
      events: "Eventi",
      contact: "Contatti",
      cta: "Parliamo del tuo progetto",
    },
    seo: {
      home: {
        title: "Delta Pictures | Gruppo Editoriale e Agenzia di Comunicazione",
        desc: "Delta Pictures è un gruppo editoriale e un'agenzia di comunicazione. Costruiamo contenuti, identità e reputazione per aziende, brand e istituzioni.",
      },
    },
    hero: {
      eyebrow: "Gruppo editoriale · Agenzia di comunicazione · Dal 2009",
      titleLines: ["Costruiamo contenuti,", "identità", "e reputazione."],
      subtitle:
        "Editoria, branding e comunicazione in un unico ecosistema. Dalla strategia alla produzione, fino alla distribuzione.",
      ctaPrimary: "",
      ctaSecondary: "",
      scroll: "Scorri",
    },
    kpis: [
      { value: 9, suffix: "M+", label: "Utenti raggiunti ogni mese" },
      { value: 15, suffix: "", label: "Verticali editoriali" },
      { value: 365, suffix: "", label: "Giorni di pubblicazione" },
      { value: 15, suffix: "+", label: "Anni di esperienza" },
      { value: 500, suffix: "+", label: "Clienti e partner" },
    ],
    ecosystem: {
      eyebrow: "Chi siamo",
      title: "Editoria e comunicazione, in un unico ecosistema.",
      body:
        "Delta Pictures è un gruppo editoriale e un'agenzia di comunicazione. Creiamo media e contenuti proprietari e affianchiamo aziende, marchi e professionisti nella costruzione dell'identità, del posizionamento e della reputazione.",
      areas: [
        {
          num: "A",
          title: "Editoria",
          desc: "Un network di testate e magazine digitali che informa e pubblica contenuti 365 giorni all'anno.",
          tag: "1 Testata · 15 verticali",
        },
        {
          num: "B",
          title: "Brand identity e posizionamento",
          desc: "Strategia, identità, immagine e tono di voce per costruire marchi riconoscibili, coerenti e distintivi.",
          tag: "Strategia",
        },
        {
          num: "C",
          title: "Comunicazione",
          desc: "Strategie di comunicazione, content marketing, PR digitali, reputazione e campagne integrate.",
          tag: "Multicanale",
        },
        {
          num: "D",
          title: "Personal branding",
          desc: "Strategia, immagine e contenuti per imprenditori, manager e professionisti.",
          tag: "Persone",
        },
        {
          num: "E",
          title: "Video e contenuti",
          desc: "Ideazione e produzione di video, format, interviste e contenuti per web, social e media.",
          tag: "4 canali · Modo",
        },
        {
          num: "F",
          title: "Progetti speciali",
          desc: "Eventi, tavole rotonde, format editoriali e progetti su misura per aziende e istituzioni.",
          tag: "Su richiesta",
        },
      ],
    },
    network: {
      eyebrow: "Il nostro network",
      title: "1 Testata giornalistica.\n15 Verticali.",
      mediaKit: "Media Kit",
      subtitle:
        "Un portafoglio editoriale verticale costruito nel tempo, capace di parlare ogni giorno a pubblici diversi attraverso informazione, approfondimento e contenuti specializzati.",
      filters: ["Tutti", "News", "Food", "Automotive", "Entertainment", "Economia", "Sport", "Lifestyle", "Video"],
      cta: "Scopri il progetto",
    },
    video: {
      eyebrow: "Video e format",
      title: "Dall'articolo al video.\nDal pubblico alla comunità.",
      body:
        "Interviste, prove su strada, dirette, format editoriali e produzioni brandizzate. I canali Modo trasformano ogni verticale in un format video pensato per YouTube e i social.",
      items: [
        { name: "Modo News", cat: "Attualità", desc: "Il notiziario video del network. Approfondimenti quotidiani.", stat: "12M+ visualizzazioni", url: "https://www.youtube.com/@modo-news" },
        { name: "Modo Motori", cat: "Motori", desc: "Prove su strada, novità, test e interviste ai protagonisti.", stat: "45+ marche", url: "https://www.youtube.com/@modo-motori" },
        { name: "Modo Food", cat: "Cucina e lifestyle", desc: "Ricette, chef, tendenze e produzioni brandizzate nel mondo del cibo.", stat: "In arrivo", comingSoon: true, url: "https://www.youtube.com/@Modo-Food" },
        { name: "Modo Economia", cat: "Economia e finanza", desc: "Il nuovo canale video dedicato a economia, mercati e imprese.", stat: "In arrivo", comingSoon: true, url: "https://www.youtube.com/@Modo-Economia" },
      ],
    },
    solutions: {
      eyebrow: "Soluzioni",
      title: "Sei competenze. Un'unica strategia.",
      body:
        "Dall'identità del marchio alla sua comunicazione. Costruiamo progetti su misura integrando strategia, creatività, contenuti, media e distribuzione.",
      items: [
        { n: "01", t: "Brand identity e posizionamento", d: "Identità, valori, immagine, tono di voce e strategia per costruire un posizionamento distintivo e coerente." },
        { n: "02", t: "Personal branding e reputazione", d: "Strategia, immagine e contenuti per costruire autorevolezza, riconoscibilità e presenza." },
        { n: "03", t: "Comunicazione e contenuti", d: "Concept, storytelling, branded content, articoli e progetti editoriali per aziende e marchi." },
        { n: "04", t: "PR, media e visibilità", d: "PR digitali, native advertising, campagne media e strategie di distribuzione multicanale." },
        { n: "05", t: "Social e video", d: "Strategia, ideazione, produzione e distribuzione di contenuti per social, YouTube e piattaforme digitali." },
        { n: "06", t: "Eventi e progetti speciali", d: "Eventi, tavole rotonde, format proprietari e progetti personalizzati per aziende e istituzioni." },
      ],
    },
    projects: {
      eyebrow: "Progetti speciali",
      title: "Case study.",
      body: "Alcuni dei progetti più importanti realizzati per brand, istituzioni e partner.",
    },
    manifesto: {
      eyebrow: "Perché Delta Pictures",
      title: "Non siamo solo editori.\nNon siamo solo un'agenzia.\nUniamo strategia, contenuti, media e distribuzione.",
      chapters: [
        { n: "I.", t: "Esperienza editoriale", d: "Conosciamo i contenuti perché li produciamo, pubblichiamo e distribuiamo ogni giorno." },
        { n: "II.", t: "Strategia e creatività", d: "Partiamo dagli obiettivi per costruire identità, posizionamento e comunicazione." },
        { n: "III.", t: "Produzione interna", d: "Articoli, video, format, social, branded content, campagne ed eventi." },
        { n: "IV.", t: "Media e distribuzione", d: "Un ecosistema editoriale, video e digitale attraverso cui dare forza e diffusione ai progetti." },
        { n: "V.", t: "Progetti su misura", d: "Non partiamo da soluzioni predefinite. Costruiamo strategie e progetti sulla base delle esigenze e degli obiettivi del cliente." },
      ],
    },
    numbers: {
      eyebrow: "Numeri",
      title: "Delta Pictures, in numeri.",
    },
    testimonials: {
      eyebrow: "Loro parlano di noi",
      title: "Fiducia, ricostruita ogni giorno.",
      items: [
        { q: "Delta Pictures ha trasformato la nostra strategia editoriale in un vero motore di acquisizione clienti.", who: "Marketing Director", where: "Automotive OEM" },
        { q: "Un partner che unisce redazione, produzione video e distribuzione. Rarissimo trovarli tutti insieme.", who: "Head of Communications", where: "Financial Services" },
        { q: "Hanno costruito con noi un format video che oggi è un asset ricorrente della nostra comunicazione.", who: "Brand Manager", where: "Food & Beverage" },
      ],
    },
    marquee: "Costruiamo contenuti • Costruiamo identità • Costruiamo reputazione • Delta Pictures • Gruppo editoriale e agenzia di comunicazione •",
    videoStrip: {
      eyebrow: "● REC · Canali video del gruppo",
      title: "Modo",
      body:
        "I verticali video di Delta Pictures ampliano l'offerta editoriale del gruppo attraverso nuovi linguaggi, format e modalità di distribuzione.",
      link: "Scopri i canali Modo",
      soon: "In arrivo",
    },
    categories: {
      News: "Attualità",
      Food: "Cucina",
      Automotive: "Motori",
      Entertainment: "Spettacolo",
      Lifestyle: "Stile di vita",
      Business: "Economia",
      Sport: "Sport",
      Video: "Video",
      Benessere: "Benessere",
      Travel: "Viaggi",
    },
    finalCta: {
      eyebrow: "Iniziamo",
      title: "Costruiamo insieme il prossimo progetto.",
      body: "Raccontateci il vostro obiettivo. Svilupperemo una soluzione capace di unire contenuti, pubblico e distribuzione.",
      primary: "Parliamo del tuo progetto",
      secondary: "Scarica il Media Kit",
    },
    footer: {
      offices: "Sedi",
      biella: "Biella",
      milan: "Milano",
      legal: "Delta Pictures S.r.l. — Tutti i diritti riservati.",
      privacy: "Privacy",
      cookies: "Cookies",
      pec: "PEC",
      contacts: "Contatti",
      tagline: "Gruppo editoriale · Agenzia di comunicazione",
      brochure: "Scarica la Brochure 2026",
      legalLinks: [
        { label: "Disclaimer", url: "/disclaimer" },
        { label: "Privacy Policy", url: "/privacy-policy" },
        { label: "Cookie Policy", url: "/cookie-policy" },
        { label: "Codice Etico", url: "/codice-etico" },
        { label: "Gestione Consenso Cookie", url: "/cookie-policy" },
      ],
      social: [
        { label: "Instagram", url: "https://www.instagram.com/gruppo_delta_pictures" },
        { label: "LinkedIn", url: "https://www.linkedin.com/company/delta-pictures" },
      ],
    },
    contact: {
      eyebrow: "Contatti",
      title: "Costruiamo\ninsieme.",
      body: "Un breve modulo. Vi rispondiamo entro un giorno lavorativo con una proposta concreta.",
      form: {
        name: "Nome e cognome",
        company: "Azienda",
        email: "Email",
        phone: "Telefono",
        projectType: "Tipologia di progetto",
        projectTypeOptions: ["Contenuti brandizzati", "Media e pubblicità", "Video e format", "PR digitali", "Eventi", "Altro"],
        budget: "Budget indicativo (facoltativo)",
        budgetOptions: ["< 10K €", "10K – 30K €", "30K – 80K €", "80K+ €", "Da definire"],
        message: "Raccontateci il progetto",
        submit: "Invia la richiesta",
        sending: "Invio in corso…",
        success: "Grazie. Vi risponderemo entro un giorno lavorativo.",
        error: "Qualcosa non ha funzionato. Riprovate o scriveteci direttamente.",
      },
      direct: "Contatti diretti",
      email: "info@deltapictures.it",
      phone: "+39 015 247 16 79",
      emailLabel: "Email",
      phoneLabel: "Telefono",
      privacy: "Inviando la richiesta accettate la nostra policy sulla privacy. Non condividiamo mai i vostri dati.",
    },
    group: {
      eyebrow: "Il Gruppo",
      title: "Quindici anni.\nQuindici testate.\nUn solo ecosistema.",
      body:
        "Nasciamo digitali. Cresciamo come gruppo editoriale. Oggi siamo un gruppo editoriale che unisce redazione, produzione video, comunicazione ed eventi.",
      timeline: [
        { year: "2009", t: "Nasce Delta Pictures", d: "Il primo progetto editoriale digitale della società, con base a Biella." },
        { year: "2013", t: "Il network cresce", d: "Nascono le prime testate verticali: attualità, cucina, motori, spettacolo." },
        { year: "2017", t: "Produzione video", d: "Debutta la divisione video con format proprietari e produzioni brandizzate." },
        { year: "2020", t: "Sede Milano", d: "Apertura della sede di Milano. Consolidamento della struttura commerciale." },
        { year: "2023", t: "I canali Modo", d: "Lancio dei canali video Modo News, Modo Motori, Modo Food." },
        { year: "2025", t: "Gruppo editoriale", d: "Delta Pictures oggi: 1 testata giornalistica, 15 verticali, 4 canali video Modo, 9M+ utenti/mese." },
      ],
      values: [
        { t: "Autorevolezza", d: "Redazioni proprietarie, verticali, giornalisticamente serie." },
        { t: "Continuità", d: "Pubblichiamo 365 giorni all'anno. Nessuna pausa editoriale." },
        { t: "Distribuzione", d: "Web, video, social, newsletter, eventi. Un ecosistema, non un canale." },
      ],
    },
  },
  en: {
    nav: {
      chiSiamo: "Who we are",
      network: "Our network",
      video: "Video channels",
      percheNoi: "Why us",
      solutions: "Solutions",
      numeri: "Numbers",
      group: "The Group",
      projects: "Projects",
      events: "Events",
      contact: "Contact",
      cta: "Let's build your project",
    },
    seo: {
      home: {
        title: "Delta Pictures | Publishing Group & Communication Agency",
        desc: "Delta Pictures is a publishing group and a communication agency. We build content, identity and reputation for companies, brands and institutions.",
      },
    },
    hero: {
      eyebrow: "Publishing group · Communication agency · Since 2009",
      titleLines: ["We build content,", "identity", "and reputation."],
      subtitle:
        "Publishing, branding and communication in one single ecosystem. From strategy to production, through to distribution.",
      ctaPrimary: "Discover the Group",
      ctaSecondary: "Work with us",
      scroll: "Scroll",
    },
    kpis: [
      { value: 9, suffix: "M+", label: "Monthly users reached" },
      { value: 15, suffix: "", label: "Editorial verticals" },
      { value: 365, suffix: "", label: "Days of publishing" },
      { value: 15, suffix: "+", label: "Years of experience" },
      { value: 500, suffix: "+", label: "Clients & partners" },
    ],
    ecosystem: {
      eyebrow: "About us",
      title: "Publishing and communication, in one single ecosystem.",
      body:
        "Delta Pictures is a publishing group and a communication agency. We create proprietary media and content, and we support companies, brands and professionals in building identity, positioning and reputation.",
      areas: [
        { num: "A", title: "Publishing", desc: "A network of outlets and digital magazines that informs and publishes content 365 days a year.", tag: "1 outlet · 15 verticals" },
        { num: "B", title: "Brand identity & positioning", desc: "Strategy, identity, image and tone of voice to build recognisable, coherent and distinctive brands.", tag: "Strategy" },
        { num: "C", title: "Communication", desc: "Communication strategies, content marketing, digital PR, reputation and integrated campaigns.", tag: "Multichannel" },
        { num: "D", title: "Personal branding", desc: "Strategy, image and content for entrepreneurs, managers and professionals.", tag: "People" },
        { num: "E", title: "Video & Content", desc: "Concept and production of videos, formats, interviews and content for web, social and media.", tag: "4 channels · Modo" },
        { num: "F", title: "Special Projects", desc: "Events, roundtables, editorial formats and tailor-made projects for companies and institutions.", tag: "On demand" },
      ],
    },
    network: {
      eyebrow: "Our network",
      title: "1 Registered outlet.\n15 Verticals.",
      mediaKit: "Media Kit",
      subtitle: "A vertical publishing portfolio built over time, able to speak every day to different audiences through news, in-depth analysis and specialised content.",
      filters: ["All", "News", "Food", "Automotive", "Entertainment", "Business", "Sport", "Lifestyle", "Video"],
      cta: "Explore project",
    },
    video: {
      eyebrow: "Video & format",
      title: "From article to video.\nFrom audience to community.",
      body:
        "Interviews, test drives, live shows, editorial formats and branded production. Modo channels turn every vertical into a video format built for YouTube and social.",
      items: [
        { name: "Modo News", cat: "News · Current affairs", desc: "The video newsroom of the network. Daily insight.", stat: "12M+ views", url: "https://www.youtube.com/@modo-news" },
        { name: "Modo Motori", cat: "Automotive", desc: "Test drives, releases, road tests and interviews.", stat: "45+ brands", url: "https://www.youtube.com/@modo-motori" },
        { name: "Modo Food", cat: "Food & Lifestyle", desc: "Recipes, chefs, trends and branded production in food.", stat: "Coming soon", comingSoon: true, url: "https://www.youtube.com/@Modo-Food" },
        { name: "Modo Economia", cat: "Business & Finance", desc: "The new video channel dedicated to economy, markets and business.", stat: "Coming soon", comingSoon: true, url: "https://www.youtube.com/@Modo-Economia" },
      ],
    },
    solutions: {
      eyebrow: "Solutions",
      title: "Six areas of expertise. One single strategy.",
      body: "From brand identity to communication. We build tailor-made projects integrating strategy, creativity, content, media and distribution.",
      items: [
        { n: "01", t: "Brand identity & positioning", d: "Identity, values, image, tone of voice and strategy to build a distinctive, coherent positioning." },
        { n: "02", t: "Personal branding & reputation", d: "Strategy, image and content to build authority, recognisability and presence." },
        { n: "03", t: "Communication & content", d: "Concepts, storytelling, branded content, articles and editorial projects for companies and brands." },
        { n: "04", t: "PR, media & visibility", d: "Digital PR, native advertising, media campaigns and multichannel distribution strategies." },
        { n: "05", t: "Social & video", d: "Strategy, concept, production and distribution of content for social media, YouTube and digital platforms." },
        { n: "06", t: "Events & special projects", d: "Events, roundtables, proprietary formats and customised projects for companies and institutions." },
      ],
    },
    projects: {
      eyebrow: "Special projects",
      title: "Case study.",
      body: "A selection of the most significant projects delivered for brands, institutions and partners.",
    },
    manifesto: {
      eyebrow: "Why Delta Pictures",
      title: "We are not just publishers.\nWe are not just an agency.\nWe combine strategy, content, media and distribution.",
      chapters: [
        { n: "I.", t: "Editorial expertise", d: "We know content because we produce, publish and distribute it every single day." },
        { n: "II.", t: "Strategy & creativity", d: "We start from goals to build identity, positioning and communication." },
        { n: "III.", t: "In-house production", d: "Articles, videos, formats, social, branded content, campaigns and events." },
        { n: "IV.", t: "Media & distribution", d: "An editorial, video and digital ecosystem that gives strength and reach to every project." },
        { n: "V.", t: "Tailor-made projects", d: "We never start from off-the-shelf solutions. We build strategies and projects around the client's needs and goals." },
      ],
    },
    numbers: { eyebrow: "Numbers", title: "Delta Pictures, in numbers." },
    testimonials: {
      eyebrow: "What they say",
      title: "Trust, rebuilt every day.",
      items: [
        { q: "Delta Pictures turned our editorial strategy into a real customer acquisition engine.", who: "Marketing Director", where: "Automotive OEM" },
        { q: "A partner that combines newsroom, video production and distribution. Very rare.", who: "Head of Communications", where: "Financial Services" },
        { q: "They built a recurring video format that is now a core asset of our communication.", who: "Brand Manager", where: "Food & Beverage" },
      ],
    },
    marquee: "We build content • We build identity • We build reputation • Delta Pictures • Italian media company •",
    videoStrip: {
      eyebrow: "● REC · Group video channels",
      title: "Modo",
      body:
        "Delta Pictures' video verticals expand the group's editorial offering through new languages, formats and distribution methods.",
      link: "Explore Modo channels",
      soon: "Soon",
    },
    categories: {
      News: "News",
      Food: "Food",
      Automotive: "Automotive",
      Entertainment: "Entertainment",
      Lifestyle: "Lifestyle",
      Business: "Business",
      Sport: "Sport",
      Video: "Video",
      Benessere: "Wellness",
      Travel: "Travel",
    },
    finalCta: {
      eyebrow: "Start",
      title: "Let's build the next project together.",
      body: "Tell us your goal. We'll build a solution that connects content, audience and distribution.",
      primary: "Let's build your project",
      secondary: "Download the Media Kit",
    },
    footer: {
      offices: "Offices",
      biella: "Biella (HQ)",
      milan: "Milan",
      legal: "Delta Pictures S.r.l. — All rights reserved.",
      privacy: "Privacy",
      cookies: "Cookies",
      pec: "Certified email",
      contacts: "Contact",
      tagline: "Publishing group · Communication agency",
      brochure: "Download the 2026 Brochure",
      legalLinks: [
        { label: "Disclaimer", url: "/disclaimer" },
        { label: "Privacy Policy", url: "/privacy-policy" },
        { label: "Cookie Policy", url: "/cookie-policy" },
        { label: "Codice Etico", url: "/codice-etico" },
        { label: "Gestione Consenso Cookie", url: "/cookie-policy" },
      ],
      social: [
        { label: "Instagram", url: "https://www.instagram.com/gruppo_delta_pictures" },
        { label: "LinkedIn", url: "https://www.linkedin.com/company/delta-pictures" },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's build\ntogether.",
      body: "One short form. We reply within one working day with a concrete proposal.",
      form: {
        name: "Full name",
        company: "Company",
        email: "Email",
        phone: "Phone",
        projectType: "Project type",
        projectTypeOptions: ["Branded content", "Media & advertising", "Video & format", "Digital PR", "Events", "Other"],
        budget: "Indicative budget (optional)",
        budgetOptions: ["< 10K €", "10K – 30K €", "30K – 80K €", "80K+ €", "TBD"],
        message: "Tell us about the project",
        submit: "Send request",
        sending: "Sending…",
        success: "Thanks. We will reply within one working day.",
        error: "Something went wrong. Please try again or write to us directly.",
      },
      direct: "Direct contact",
      email: "info@deltapictures.it",
      phone: "+39 015 247 16 79",
      emailLabel: "Email",
      phoneLabel: "Phone",
      privacy: "By submitting this request you accept our privacy policy. We never share your data.",
    },
    group: {
      eyebrow: "The Group",
      title: "Fifteen years.\nFifteen titles.\nOne ecosystem.",
      body: "Born digital. Grown as a publishing group. Today a media company that unites newsroom, video production, communication and events.",
      timeline: [
        { year: "2009", t: "Delta Pictures is founded", d: "The company's first digital editorial project, based in Biella." },
        { year: "2013", t: "The network grows", d: "First vertical titles emerge: news, food, automotive, entertainment." },
        { year: "2017", t: "Video production", d: "The video division debuts with in-house formats and branded production." },
        { year: "2020", t: "Milan office", d: "Milan office opens. Sales structure is consolidated." },
        { year: "2023", t: "Modo channels", d: "Launch of Modo News, Modo Motori, Modo Food video channels." },
        { year: "2025", t: "Publishing group", d: "Delta Pictures today: 1 registered outlet, 15 verticals, 4 Modo video channels, 9M+ monthly users." },
      ],
      values: [
        { t: "Authority", d: "In-house newsrooms, vertical, serious journalism." },
        { t: "Continuity", d: "We publish 365 days a year. No editorial breaks." },
        { t: "Distribution", d: "Web, video, social, newsletter, events. An ecosystem, not a channel." },
      ],
    },
  },
};

export const magazines = [
  { name: "NewsMondo", cat: "News", desc: { it: "News quotidiane, attualità, politica e cronaca.", en: "Daily news, current affairs, politics and reporting." }, url: "https://www.newsmondo.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/newsmondo.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/newsmondo.jpg` },
  { name: "PrimoChef", cat: "Food", desc: { it: "Ricette, tecniche e cultura gastronomica.", en: "Recipes, techniques and food culture." }, url: "https://www.primochef.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/primochef.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/primochef.jpg` },
  { name: "Mondo Motori", cat: "Automotive", desc: { it: "Novità, prove su strada, mercato auto e moto.", en: "News, road tests, car and motorbike market." }, url: "https://mondo-motori.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/mondo-motori.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/mondo-motori.jpg` },
  { name: "Popcorn TV", cat: "Entertainment", desc: { it: "Cinema, serie TV, streaming e cultura pop.", en: "Cinema, TV series, streaming and pop culture." }, url: "https://www.popcorntv.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/popcorntv.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/popcorntv.jpg` },
  { name: "Donna Glamour", cat: "Lifestyle", desc: { it: "Bellezza, moda, benessere e ispirazione femminile.", en: "Beauty, fashion, wellness and inspiration for women." }, url: "https://www.donnaglamour.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/donnaglamour.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/donnaglamour.jpg` },
  { name: "Economia Finanza Online", cat: "Business", desc: { it: "Economia, mercati, finanza personale e imprese.", en: "Economy, markets, personal finance and business." }, url: "https://www.economiafinanzaonline.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/economiafinanzaonline.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/economiafinanzaonline.jpg` },
  { name: "Notizie Musica", cat: "Entertainment", desc: { it: "News, uscite, live e classifiche del mondo musicale.", en: "News, releases, live shows and charts from the music world." }, url: "https://www.notiziemusica.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/notiziemusica.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/notiziemusica.jpg` },
  { name: "Dolci Veloci", cat: "Food", desc: { it: "Ricette dolci, tecniche facili, tendenze bakery.", en: "Sweet recipes, easy techniques and bakery trends." }, url: "https://www.dolciveloci.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/dolciveloci.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/dolciveloci.jpg` },
  { name: "Notizie Milan", cat: "Sport", desc: { it: "News, formazioni, mercato e analisi del Milan.", en: "News, line-ups, transfers and analysis on Milan." }, url: "https://www.notiziemilan.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/notiziemilan.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/notiziemilan.webp` },
  { name: "Notizie Inter", cat: "Sport", desc: { it: "News, formazioni, mercato e analisi dell'Inter.", en: "News, line-ups, transfers and analysis on Inter." }, url: "https://www.notizie-inter.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/notizieinter.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/notizieinter.webp` },
  { name: "Notizie Juventus", cat: "Sport", desc: { it: "News, formazioni, mercato e analisi della Juventus.", en: "News, line-ups, transfers and analysis on Juventus." }, url: "https://www.notiziejuventus.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/notiziejuventus.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/notiziejuventus.webp` },
  { name: "Motori News 24", cat: "Automotive", desc: { it: "Attualità, mercato, novità e approfondimenti motoristici.", en: "News, market updates and automotive insights." }, url: "https://www.motorinews24.com", mediaKit: `${process.env.PUBLIC_URL}/mediakit/motorinews24.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/motorinews24.jpg` },
  { name: "Notizie Benessere", cat: "Benessere", desc: { it: "Salute, benessere, alimentazione e stili di vita.", en: "Health, wellness, nutrition and lifestyle." }, url: "https://www.notiziebenessere.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/notiziebenessere.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/notiziebenessere.jpg` },
  { name: "Wellness Trends", cat: "Benessere", desc: { it: "Tendenze wellness, fitness, mindfulness e lifestyle sano.", en: "Wellness trends, fitness, mindfulness and healthy lifestyle." }, url: "https://www.wellness-trends.com", mediaKit: `${process.env.PUBLIC_URL}/mediakit/wellnesstrends.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/wellnesstrends.jpg` },
  { name: "Viaggiare Travel", cat: "Travel", desc: { it: "Mete, itinerari, guide di viaggio ed esperienze.", en: "Destinations, itineraries, travel guides and experiences." }, url: "https://viaggiaretravel.it", mediaKit: `${process.env.PUBLIC_URL}/mediakit/viaggiaretravel.pdf`, img: `${process.env.PUBLIC_URL}/images/magazines/viaggiaretravel.jpg` },
];

export const caseStudies = [
  {
    title: "Automotive Launch",
    client: "Automotive OEM",
    tag: "Branded content · Video",
    desc: "Lancio integrato di un nuovo modello attraverso testate, canale video Modo Motori e social.",
    metric: "+38% brand consideration",
    image:
      `${process.env.PUBLIC_URL}/images/cases/auto.jpg`,
  },
  {
    title: "Financial Reputation",
    client: "Financial Services",
    tag: "Content marketing · Digital PR",
    desc: "Programma editoriale annuale su Economia Finanza Online per consolidare la reputazione istituzionale.",
    metric: "180+ contenuti in 12 mesi",
    image:
      `${process.env.PUBLIC_URL}/images/hero.jpg`,
  },
  {
    title: "Food Format Series",
    client: "Food & Beverage",
    tag: "Video format · Social",
    desc: "Serie video branded su Modo Food, distribuita su YouTube, Instagram e newsletter di PrimoChef.",
    metric: "2.4M views · 6 episodi",
    image:
      `${process.env.PUBLIC_URL}/images/cases/food.jpg`,
  },
  {
    title: "Institutional Event",
    client: "Public Institution",
    tag: "Eventi · Progetti speciali",
    desc: "Evento istituzionale con tavola rotonda, produzione video, live streaming e copertura editoriale.",
    metric: "12 relatori · 400 partecipanti",
    image:
      `${process.env.PUBLIC_URL}/images/cases/evento.jpg`,
  },
];

export const partners = [
  "OEM Auto", "Banca Nazionale", "Grande Distribuzione", "Fashion House", "Tech Italia",
  "Fondazione Culturale", "Editoria", "Energia S.p.A.", "Assicurazioni", "Consumer Goods",
];
